<template>
  <div style="width:100%; height:100%;">
    <div class="mt-5 ml-5 mr-5" v-if="showMobileView">
      <v-hover
        class="mt-1"
        v-slot:default="{ hover }"
        v-for="(option, i) in options"
        :key="i"
      >
        <v-card
          class="d-flex align-center pl-5"
          :elevation="hover ? 16 : 2"
          :to="option.value"
        >
          <v-col cols="10" class="pa-0">
            <div class="text-h6 font-weight-medium">{{ option.name }}</div>
          </v-col>
          <v-col cols="2">
            <v-icon x-large>mdi-chevron-right</v-icon>
          </v-col>
        </v-card>
      </v-hover>
      <v-hover class="mt-1" v-slot:default="{ hover }">
        <v-card
          class="d-flex align-center pl-5"
          :elevation="hover ? 16 : 2"
          @click="checkLogStatus"
        >
          <v-col cols="10" class="pa-0" style="color: red;">
            <div class="text-h6 font-weight-medium" v-if="isLoggedIn">
              LOGOUT
            </div>
            <div class="text-h6 font-weight-medium" v-else>
              LOGIN
            </div>
          </v-col>
          <v-col cols="2">
            <v-icon x-large>mdi-chevron-right</v-icon>
          </v-col>
        </v-card>
      </v-hover>
    </div>
    <div class="pa-4" style="width:100%;  height:100%;" v-if="!showMobileView">
      <v-card style="width:100%; height:100%;" class="font-weight-bold pt-1">
        <div
          v-for="(option, i) in options"
          :style="checkBackground(option.value)"
          :key="i"
          :id="
            option.value
              .toLowerCase()
              .split('/')
              .pop()
          "
          class="ma-4 pa-2 menu-option"
          @click="goToRoute(option.value)"
        >
          {{ option.name }}
        </div>
        <div
          class="ma-4 pa-2"
          style="cursor: pointer"
          v-if="isLoggedIn"
          @click="checkLogStatus"
          id="logout"
        >
          LOGOUT
        </div>
        <div class="ma-4 pa-2" v-else @click="checkLogStatus" id="login">
          LOGIN
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { MobileView, UserPermissions } from '@/mixins';

export default {
  name: 'accountpage',
  data: () => ({}),
  mixins: [MobileView, UserPermissions],
  methods: {
    ...mapActions({
      _logOut: 'auth/logOut',
    }),
    checkLogStatus() {
      if (this.isLoggedIn) {
        this._logOut();
        this.$router.push('/login');
      } else {
        this.$router.push('/login');
      }
    },
    goToRoute(value) {
      this.$router.push(value);
    },
    checkBackground(value) {
      if (value === this.$route.path) {
        return 'background-color: #EFEFEF;';
      }
      return '';
    },
  },
  mounted() {
    if (!this.showMobileView && this.$route.name === 'Account') {
      this.$router
        .push(
          `/${this.currentClient.client_name
            .toLowerCase()
            .replace(/\s/g, '')}/account/profile`
        )
        .catch(err => {
          err;
        });
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/getIsLoggedIn',
      currentClient: 'account/getCurrentClient',
    }),
    options() {
      const options = [
        {
          name: 'PERSONAL PROFILE',
          value: `/${this.currentClient.client_name
            .toLowerCase()
            .replace(/\s/g, '')}/account/profile`,
        },
      ];
      if (this.isAdmin) {
        options.push({
          name: 'COMPANY PROFILE',
          value: `/${this.currentClient.client_name
            .toLowerCase()
            .replace(/\s/g, '')}/account/client`,
        });
        options.push({
          name: 'SYSTEM USERS',
          value: `/${this.currentClient.client_name
            .toLowerCase()
            .replace(/\s/g, '')}/account/users`,
        });
      }
      return options;
    },
  },
};
</script>

<style>
.menu-option:hover {
  cursor: pointer;
}
</style>
